import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import BillingBox from '../../components/admin/BillingBox'
import CurriculumLayout from '../../components/layout/CurriculumLayout'

const Billing = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Invoice'}>
          <BillingBox />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default Billing
